<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">e way Energy · Leistungsspektrum</p>

      <h2 class="presentation-page__title">EPC &amp; O&amp;M aus einer Hand</h2>

      <p class="presentation-page__text">
        Vier Phasen, ein Partner. Keine Schnittstellenrisiken zwischen Planung, Bau und Betrieb.
      </p>

      <div class="presentation-page__group-cards presentation-page__group-cards--four">
        <article v-for="phase in phases" :key="phase.header" class="presentation-page__group-card">
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${phase.accent}`,
            ]"
          >
            {{ phase.header }}
          </div>

          <div class="presentation-page__group-card-body presentation-page__group-card-body--phase">
            <div
              :class="[
                'presentation-page__group-card-icon',
                `presentation-page__group-card-icon--${phase.accent}`,
              ]"
              aria-hidden="true"
            >
              <i :class="['fa', phase.icon]"></i>
            </div>

            <h3 class="presentation-page__group-card-title">{{ phase.title }}</h3>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <ul class="presentation-page__list">
              <li v-for="item in phase.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage07',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      phases: [
        {
          header: 'Engineering',
          accent: 'brand-teal',
          icon: 'fa-pencil-square-o',
          title: 'Planung & Genehmigung',
          items: [
            'Statikprüfung & Tragwerksgutachten',
            'Ertragsgutachten (P50)',
            'Netzverträglichkeitsprüfung',
            'Behördenkommunikation',
          ],
        },
        {
          header: 'Procurement',
          accent: 'brand-secondary',
          icon: 'fa-cubes',
          title: 'Komponenten & Beschaffung',
          items: [
            'Premium-Module (Tier-1)',
            'Wechselrichter mit Hersteller-Garantie',
            'Unterkonstruktion mit TÜV-Zertifikat',
            'Speicher-Optionen',
          ],
        },
        {
          header: 'Construction',
          accent: 'brand-primary',
          icon: 'fa-wrench',
          title: 'Installation',
          items: [
            'Schlüsselfertige Errichtung',
            'Versicherter Bauprozess',
            'Netzanschluss inkl. Zähler',
            'Inbetriebnahme & Marktstammdaten',
          ],
        },
        {
          header: 'Operation',
          accent: 'brand-teal',
          icon: 'fa-tachometer',
          title: '20-Jahre-Betrieb',
          items: [
            'Online-Monitoring 24/7',
            'Präventive Wartung',
            'Reparaturen unter Garantie',
            'Versicherungspaket inklusive',
          ],
        },
      ],
    };
  },
};
</script>
